import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import PropTypes from "prop-types";

function arrowGenerator(color) {
    return {
        '&[x-placement*="bottom"] $arrow': {
            top: 0,
            left: 0,
            marginTop: "-0.95em",
            width: "3em",
            height: "1em",
            "&::before": {
                borderWidth: "0 1em 1em 1em",
                borderColor: `transparent transparent ${color} transparent`
            }
        },
        '&[x-placement*="top"] $arrow': {
            bottom: 0,
            left: 0,
            marginBottom: "-0.95em",
            width: "3em",
            height: "1em",
            "&::before": {
                borderWidth: "1em 1em 0 1em",
                borderColor: `${color} transparent transparent transparent`
            }
        },
        '&[x-placement*="right"] $arrow': {
            left: 0,
            marginLeft: "-0.95em",
            height: "3em",
            width: "1em",
            "&::before": {
                borderWidth: "1em 1em 1em 0",
                borderColor: `transparent ${color} transparent transparent`
            }
        },
        '&[x-placement*="left"] $arrow': {
            right: 0,
            marginRight: "-0.95em",
            height: "3em",
            width: "1em",
            "&::before": {
                borderWidth: "1em 0 1em 1em",
                borderColor: `transparent transparent transparent ${color}`
            }
        }
    };
}

const useStylesBootstrap = makeStyles(theme => ({
    arrow: {
        position: "absolute",
        fontSize: 6,
        width: "3em",
        height: "3em",
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: 0,
            height: 0,
            borderStyle: "solid"
        }
    },
    popper: arrowGenerator('lightgrey'),
    tooltip: {
        position: "relative",
        backgroundColor: theme.palette.common.white,
        boxShadow: theme.shadows[1],
        color: theme.palette.common.black,
        fontSize: 16,
        maxWidth: 'none'
    },
    tooltipPlacementLeft: {
        margin: "0 8px"
    },
    tooltipPlacementRight: {
        margin: "0 8px"
    },
    tooltipPlacementTop: {
        margin: "8px 0"
    },
    tooltipPlacementBottom: {
        margin: "8px 0"
    }
}));

function CustomTooltip(props) {
    const { arrow, ...classes } = useStylesBootstrap();
    const [arrowRef, setArrowRef] = React.useState(null);

    return (
        <Tooltip
            classes={classes}
            enterDelay={props.enterDelay ? props.enterDelay : 500}
            leaveDelay={props.leaveDelay ? props.leaveDelay : 250}
            PopperProps={{
                popperOptions: {
                    modifiers: {
                        arrow: {
                            enabled: Boolean(arrowRef),
                            element: arrowRef
                        }
                    }
                }
            }}
            {...props}
            title={
                <React.Fragment>
                    {props.titleText}
                    <span className={arrow} ref={setArrowRef} />
                </React.Fragment>
            }
        />
    );
}

CustomTooltip.propTypes = {
    title: PropTypes.node
};

export default function CustomizedTooltips(props) {
    return (
        props.titleText === '' 
            ? props.jsx 
            : <CustomTooltip {...props} >
                {props.jsx}
            </CustomTooltip>
    );
}